
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/[categorySlug]",
      function () {
        return require("private-next-pages/reviews/[categorySlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/[categorySlug]"])
      });
    }
  